import { Component, inject, ViewChild } from '@angular/core';

import { TagComponent } from '../../../../../common/tag/tag.component';
import { SelectedItemCounterDirective } from './selected-item-counter.directive';

@Component({
  selector: 'rt-select-selected-item-counter',
  standalone: true,
  imports: [SelectedItemCounterDirective, TagComponent],
  template: `
    <ng-container *rtSelectSelectedItemCounter="let dir; let hiddenCount = hiddenCount">
      <rt-tag [name]="'+' + hiddenCount"></rt-tag>
    </ng-container>
  `,
  providers: [
    {
      provide: SelectedItemCounterDirective,
      useFactory: () => inject(SelectedItemCounterComponent).directive,
    },
  ],
})
export class SelectedItemCounterComponent {
  @ViewChild(SelectedItemCounterDirective, { static: true })
  public directive: SelectedItemCounterDirective<any>;
}
